import React, { useState } from "react";
import { Button } from "../../components/template";

const quizData = {
  title: "Body Tox Level Assessment",
  description:
    "With the given level of pollution, poor dietary and lifestyle choices, we keep accumulating Toxins in our body which affects our energy and overall well-being. This quick test helps assess the level of Ama (toxins) in your body. Take the test now!",
  instructions: "Take the test now!",
};

const questions = [
  { category: "Digestive Tract", question: "How often do you feel nauseous or vomit?", options: ["Never/rarely", "Occasionally, but not severe", "Occasionally, but severe", "Frequently, but not severe", "Frequently, but severe"] },
  { category: "Digestive Tract", question: "How often do you have loose stools or Diarrhea?", options: ["Never/rarely", "Occasionally, but not severe", "Occasionally, but severe", "Frequently, but not severe", "Frequently, but severe"] },
  { category: "Digestive Tract", question: "How often do you experience constipation?", options: ["Never/rarely", "Occasionally, but not severe", "Occasionally, but severe", "Frequently, but not severe", "Frequently, but severe"] },
  { category: "Digestive Tract", question: "Do you frequently feel bloated or burp a lot?", options: ["Never/rarely", "Occasionally, but not severe", "Occasionally, but severe", "Frequently, but not severe", "Frequently, but severe"] },
  { category: "Digestive Tract", question: "How often do you get heartburn or foul-smelling gas?", options: ["Never/rarely", "Occasionally, but not severe", "Occasionally, but severe", "Frequently, but not severe", "Frequently, but severe"] },
  { category: "Digestive Tract", question: "Do you experience stomach or intestinal pain regularly?", options: ["Never/rarely", "Occasionally, but not severe", "Occasionally, but severe", "Frequently, but not severe", "Frequently, but severe"] },

  { category: "Head", question: "How often do you get headaches?", options: ["Never/rarely", "Occasionally, but not severe", "Occasionally, but severe", "Frequently, but not severe", "Frequently, but severe"] },
  { category: "Head", question: "Do you ever feel faint or lightheaded?", options: ["Never/rarely", "Occasionally, but not severe", "Occasionally, but severe", "Frequently, but not severe", "Frequently, but severe"] },
  { category: "Head", question: "How often do you experience dizziness?", options: ["Never/rarely", "Occasionally, but not severe", "Occasionally, but severe", "Frequently, but not severe", "Frequently, but severe"] },
  { category: "Head", question: "Do you have trouble falling or staying asleep?", options: ["Never/rarely", "Occasionally, but not severe", "Occasionally, but severe", "Frequently, but not severe", "Frequently, but severe"] },

  { category: "Joints / Muscles", question: "Do you feel aches or pain in your joints?", options: ["Never/rarely", "Occasionally, but not severe", "Occasionally, but severe", "Frequently, but not severe", "Frequently, but severe"] },
  { category: "Joints / Muscles", question: "Do your joints feel stiff or arthritic often?", options: ["Never/rarely", "Occasionally, but not severe", "Occasionally, but severe", "Frequently, but not severe", "Frequently, but severe"] },
  { category: "Joints / Muscles", question: "How often do you feel muscle aches or tension?", options: ["Never/rarely", "Occasionally, but not severe", "Occasionally, but severe", "Frequently, but not severe", "Frequently, but severe"] },
  { category: "Joints / Muscles", question: "Do you regularly feel physically weak or low on strength?", options: ["Never/rarely", "Occasionally, but not severe", "Occasionally, but severe", "Frequently, but not severe", "Frequently, but severe"] },

  { category: "Energy / Activity", question: "Do you often feel tired or sluggish?", options: ["Never/rarely", "Occasionally, but not severe", "Occasionally, but severe", "Frequently, but not severe", "Frequently, but severe"] },
  { category: "Energy / Activity", question: "How often do you feel restless or unable to sit still?", options: ["Never/rarely", "Occasionally, but not severe", "Occasionally, but severe", "Frequently, but not severe", "Frequently, but severe"] },
  { category: "Energy / Activity", question: "Do you feel the need to urinate frequently or urgently?", options: ["Never/rarely", "Occasionally, but not severe", "Occasionally, but severe", "Frequently, but not severe", "Frequently, but severe"] },

  { category: "Ears & Eyes", question: "Do your eyes or ears feel itchy often?", options: ["Never/rarely", "Occasionally, but not severe", "Occasionally, but severe", "Frequently, but not severe", "Frequently, but severe"] },
  { category: "Ears & Eyes", question: "Do you get earaches or ear infections regularly?", options: ["Never/rarely", "Occasionally, but not severe", "Occasionally, but severe", "Frequently, but not severe", "Frequently, but severe"] },
  { category: "Ears & Eyes", question: "Is there any fluid or discharge from your ears?", options: ["Never/rarely", "Occasionally, but not severe", "Occasionally, but severe", "Frequently, but not severe", "Frequently, but severe"] },
  { category: "Ears & Eyes", question: "Do you hear ringing in your ears?", options: ["Never/rarely", "Occasionally, but not severe", "Occasionally, but severe", "Frequently, but not severe", "Frequently, but severe"] },
  { category: "Ears & Eyes", question: "Have you noticed any hearing or vision loss?", options: ["Never/rarely", "Occasionally, but not severe", "Occasionally, but severe", "Frequently, but not severe", "Frequently, but severe"] },
  { category: "Ears & Eyes", question: "Do you have excessive earwax or discharge?", options: ["Never/rarely", "Occasionally, but not severe", "Occasionally, but severe", "Frequently, but not severe", "Frequently, but severe"] },

  { category: "Mouth / Throat", question: "Do you have a persistent cough?", options: ["Never/rarely", "Occasionally, but not severe", "Occasionally, but severe", "Frequently, but not severe", "Frequently, but severe"] },
  { category: "Mouth / Throat", question: "How often do you get a sore throat or feel hoarse?", options: ["Never/rarely", "Occasionally, but not severe", "Occasionally, but severe", "Frequently, but not severe", "Frequently, but severe"] },
  { category: "Mouth / Throat", question: "Is there any discoloration on your tongue, gums, or lips?", options: ["Never/rarely", "Occasionally, but not severe", "Occasionally, but severe", "Frequently, but not severe", "Frequently, but severe"] },

  { category: "Skin", question: "Do you have acne or dandruff?", options: ["Never/rarely", "Occasionally, but not severe", "Occasionally, but severe", "Frequently, but not severe", "Frequently, but severe"] },
  { category: "Skin", question: "How often do you get hives, rashes, or very dry skin?", options: ["Never/rarely", "Occasionally, but not severe", "Occasionally, but severe", "Frequently, but not severe", "Frequently, but severe"] },
  { category: "Skin", question: "Have you experienced unusual hair loss?", options: ["Never/rarely", "Occasionally, but not severe", "Occasionally, but severe", "Frequently, but not severe", "Frequently, but severe"] },

  { category: "Nose", question: "Do you often have a stuffy nose or too much mucus?", options: ["Never/rarely", "Occasionally, but not severe", "Occasionally, but severe", "Frequently, but not severe", "Frequently, but severe"] },
  { category: "Nose", question: "How often do you get sneezing fits or hay fever?", options: ["Never/rarely", "Occasionally, but not severe", "Occasionally, but severe", "Frequently, but not severe", "Frequently, but severe"] },
  { category: "Nose", question: "Do you experience nosebleeds often?", options: ["Never/rarely", "Occasionally, but not severe", "Occasionally, but severe", "Frequently, but not severe", "Frequently, but severe"] },
  { category: "Nose", question: "Do you have a reduced sense of smell?", options: ["Never/rarely", "Occasionally, but not severe", "Occasionally, but severe", "Frequently, but not severe", "Frequently, but severe"] },
];

const BodyToxinQuiz = () => {
  const [page, setPage] = useState(0);
  const [answers, setAnswers] = useState({});
  const [score, setScore] = useState(0);
  const [error, setError] = useState(""); // Error message state

  const handleOptionChange = (question, value) => {
    setAnswers((prevAnswers) => ({ ...prevAnswers, [question]: value }));
    setError(""); // Clear any error message when an option is selected
  };

  const handleNext = () => {
    // Check if an answer exists for the current question before proceeding
    if (answers[questions[page - 1]?.question] === undefined) {
      setError("Please select an option to proceed.");
      return;
    }
    setError(""); // Clear error if validation passes
    setPage(page + 1);
  };

  const handlePrev = () => {
    setError(""); // Clear error on navigating back
    setPage(page - 1);
  };

  const handleSubmit = () => {
    // Validate if an answer exists for the last question
    if (answers[questions[page - 1]?.question] === undefined) {
      setError("Please select an option to proceed.");
      return;
    }
    const totalScore = Object.values(answers).reduce((acc, val) => acc + Number(val), 0);
    setScore(totalScore);
    setPage(questions.length + 1);
  };

  const getResultCategory = (score) => {
    if (score <=10)
      return { level: "Toxin Level – Low", message: "Well done! Your lifestyle is great and fighting the toxins at optimum level. Keep it up." };
    if (score >= 11 && score <= 25)
      return { level: "Toxin Level – Moderate", message: "You are doing better than average but can improve a lot with better lifestyle choices." };
    if (score >= 26 && score <= 50)
      return { level: "Toxin Level – High", message: "Constant accumulation of toxins in body. Focus on adopting healthier dietary, recreational, and work-out routine." };
        if (score >= 51&& score <= 75)
      return { level: "Toxin Level – Excess", message: "Excess amount of toxins in body. Urgent need to adopt healthier diet , life routine." };

    if(score>50)
    return { level: "Toxin Level – Severe", message: "High amount of toxins in your body. Intervene urgently to make changes in your diet, work-out, and other lifestyle activities to avoid worsening of health." };
  };
  const { level, message } = getResultCategory(score);

  // Calculate progress based on the current question (page 1 to questions.length)
  const progressPercentage =
    page > 0 && page <= questions.length ? (page / questions.length) * 100 : 0;

  return (
    <div className="min-h-screen bg-light px-6 py-10 flex flex-col items-center text-center">
      {page === 0 ? (
        <div className="max-w-lg bg-white p-6 rounded-2xl shadow-md">
          <h1 className="text-2xl font-bold md:mb-6 text-primary">{quizData.title}</h1>
          <p className="mt-2 text-gray-700">{quizData.description}</p>
          <h2 className="mt-4 text-lg font-semibold text-[#578d48]">{quizData.instructions}</h2>
          <Button variant="primary" size="md" className="md:mt-6 mt-4" text="Start Quiz" onClick={() => setPage(1)} />
        </div>
      ) : page <= questions.length ? (
        <div className="w-full max-w-2xl bg-white p-8 rounded-2xl shadow-lg">
          {/* Progress Indicator */}
          <div className="mb-6">
            <p className="text-sm text-gray-600 mb-2">
              Question {page} of {questions.length}
            </p>
            <div className="w-full bg-gray-200 h-2 rounded-full">
              <div className="bg-primary h-2 rounded-full" style={{ width: `${progressPercentage}%` }}></div>
            </div>
          </div>
          <h2 className="text-lg text-primary">{questions[page - 1]?.category}</h2>
          <p className="mt-2 text-[#578d48] font-bold">{questions[page - 1]?.question}</p>
          <div className="mt-4 space-y-2 text-left">
            {questions[page - 1]?.options.map((option, index) => (
              <label
                key={index}
                className={`flex items-center space-x-3 p-2 rounded-lg cursor-pointer ${
                  answers[questions[page - 1]?.question] === option
                    ? "bg-primary text-white"
                    : "bg-gray-100 hover:bg-gray-200"
                }`}
              >
                <input
                  type="radio"
                  name={questions[page - 1]?.question}
                  value={option}
                  checked={answers[questions[page - 1]?.question] === option}
                  onChange={() => handleOptionChange(questions[page - 1]?.question, option)}
                  className="hidden"
                />
                <span className="text-sm">{option}</span>
              </label>
            ))}
          </div>
          {/* Display error message if no option is selected */}
          {error && <p className="mt-4 text-red-500 text-sm">{error}</p>}
          <div className={`flex mt-6 ${page > 1 ? "justify-between" : "justify-end"}`}>
            {page > 1 && <Button variant="whitish" size="md" text="Previous" onClick={handlePrev} />}
            {page === questions.length ? (
              <Button variant="primary" size="md" text="Submit" onClick={handleSubmit} />
            ) : (
              <Button variant="primary" size="md" text="Next" onClick={handleNext} />
            )}
          </div>
        </div>
      ) : (
        <div className="max-w-lg bg-white p-6 rounded-2xl shadow-md">
          <h2 className="text-xl md:text-3xl font-bold text-secondary text-center mb-4">Your Body Toxin Score</h2>
          <p className="text-md md:text-lg text-center">
            <span className="font-semibold text-primary">{level}</span>
          </p>
          <p className="text-md md:text-lg text-center md:mt-6 mt-4">
            <span className="font-semibold text-[#578d48]">{message}</span>
          </p>
          <Button variant="primary" size="md" className="mt-6" text="Retake Quiz" onClick={() => setPage(0)} />
        </div>
      )}
    </div>
  );
};

export default BodyToxinQuiz;
